import { render, staticRenderFns } from "./AdsList.vue?vue&type=template&id=8382dad8&scoped=true&"
import script from "./AdsList.vue?vue&type=script&lang=js&"
export * from "./AdsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8382dad8",
  null
  
)

export default component.exports